import React from 'react';
import { getVehicles } from '../api/vehicles';

export default function VehicleList({ onViewVehicle }) {
  const [vehicles, setVehicles] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    async function loadVehicles() {
      try {
        const data = await getVehicles();
        setVehicles(data);
      } catch (err) {
        setError(err.message || 'Failed to load vehicles');
      } finally {
        setLoading(false);
      }
    }

    loadVehicles();
  }, []);

  if (loading) {
    return <div className="loading">Loading vehicles...</div>;
  }

  if (error) {
    return <div className="error" style={{ padding: '2rem' }}>{error}</div>;
  }

  if (vehicles.length === 0) {
    return (
      <div className="empty-state">
        <h3>No vehicles found</h3>
        <p>There are no vehicles in the system yet.</p>
      </div>
    );
  }

  return (
    <div className="vehicle-list">
      <h2>Vehicles ({vehicles.length})</h2>
      <div className="vehicle-grid">
        {vehicles.map((vehicle) => (
          <div key={vehicle.id} className="vehicle-card" onClick={() => onViewVehicle(vehicle.id)}>
            <h3>{vehicle.make} {vehicle.model}</h3>
            <div className="vin">{vehicle.vin}</div>
            <div>{vehicle.year} • {vehicle.location}</div>
            <div className="details">
              <span className={`badge status-${vehicle.status}`}>
                {vehicle.status}
              </span>
              <span className="badge" style={{ background: '#e2e8f0', color: '#2d3748' }}>
                {vehicle.mileage.toLocaleString()} mi
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
